module.exports = __webpack_public_path__ + "static/img/qtcj01.96762fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj01.png
// module id = 461
// module chunks = 0